module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "title",
      rawName: "v-title",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "recharge"
  }, [_c('navtop', {
    attrs: {
      "index": ''
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "charge-con"
  }, [_c('div', {
    staticClass: "ye"
  }, [_c('p', [_vm._v("剩余齐齐豆")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.hasQiqiDou))])]), _vm._v(" "), _c('div', {
    staticClass: "chargeWrap"
  }, [_c('ul', {
    staticClass: "chargeList"
  }, [_c('li', {
    class: _vm.index == 0 && 'cur',
    on: {
      "click": function($event) {
        return _vm.selectedAmount(1, 0)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.qiqidou),
      expression: "qiqidou"
    }, {
      name: "toNumber",
      rawName: "v-toNumber"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "齐齐豆"
    },
    domProps: {
      "value": (_vm.qiqidou)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.qiqidou = $event.target.value
      }
    }
  }), _c('span', [_vm._v("万")]), _c('br'), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm._f("limitBy")(_vm.qiqidou * 10)) + "元")])]), _vm._v(" "), _c('li', {
    class: _vm.index == 1 && 'cur',
    on: {
      "click": function($event) {
        return _vm.selectedAmount(1, 1)
      }
    }
  }, [_c('p', [_vm._v("1万齐齐豆")]), _vm._v(" "), _c('a', [_vm._v("10元")])]), _vm._v(" "), _c('li', {
    class: _vm.index == 2 && 'cur',
    on: {
      "click": function($event) {
        return _vm.selectedAmount(20, 2)
      }
    }
  }, [_c('p', [_vm._v("20万齐齐豆")]), _vm._v(" "), _c('a', [_vm._v("200元")])]), _vm._v(" "), _c('li', {
    class: _vm.index == 3 && 'cur',
    on: {
      "click": function($event) {
        return _vm.selectedAmount(50, 3)
      }
    }
  }, [_c('p', [_vm._v("50万齐齐豆")]), _vm._v(" "), _c('a', [_vm._v("500元")])]), _vm._v(" "), _c('li', {
    class: _vm.index == 4 && 'cur',
    on: {
      "click": function($event) {
        return _vm.selectedAmount(300, 4)
      }
    }
  }, [_c('p', [_vm._v("300万齐齐豆")]), _vm._v(" "), _c('a', [_vm._v("3000元")])]), _vm._v(" "), _c('li', {
    class: _vm.index == 5 && 'cur',
    on: {
      "click": function($event) {
        return _vm.selectedAmount(500, 5)
      }
    }
  }, [_c('p', [_vm._v("500万齐齐豆")]), _vm._v(" "), _c('a', [_vm._v("5000元")])])]), _vm._v(" "), _c('div', {
    staticClass: "charge-btn",
    on: {
      "click": _vm.pay
    }
  }, [_vm._v("立即充值")]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), (_vm.showTips) ? _c('div', {
    staticClass: "pop"
  }, [_c('p', [_vm._v("请输入1-9999之间的数字")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showTips = false
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('i', {
    on: {
      "click": function($event) {
        _vm.showTips = false
      }
    }
  }, [_vm._v("x")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips"
  }, [_c('p', [_vm._v("充值提示:")]), _vm._v(" "), _c('p', [_vm._v("1:请确认您的账号确认无误。")]), _vm._v(" "), _c('p', [_vm._v("2:充值比例为1:1000即1元人民币=1000齐齐豆")]), _vm._v(" "), _c('p', [_vm._v("3:如果有任何问题请联系客服QQ:8007777777")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05b0503f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dating/recharge.vue
// module id = 114
// module chunks = 0